export function autosizeTextArea(element: HTMLElement, offset = 0): void {
  // https://stackoverflow.com/questions/454202/creating-a-textarea-with-auto-resize
  element.style.height = 'auto';
  element.style.height = element.scrollHeight - 5 + offset + 'px';
}
